import React, { useState } from "react";
import { Box, Stepper, Step, StepLabel, Button, Typography, Card, CardContent, CardActionArea, CardMedia, Grid } from "@mui/material";
import { AddCompnayForm } from "./AddCompnay";
// import StoreForm from "./StoreForm"; // Your store info form

const steps = ['Select Store Type', 'Select Plan Type', 'Store Information'];

export default function MultiStepForm({setshowModaladd}) {
    const [activeStep, setActiveStep] = useState(0);
    const [selectedCard, setSelectedCard] = useState(null); // for step 1 and 2 card selection
    const [formData, setFormData] = useState({
        storeType: '',
        planType: '',
    });

    const storeCards = [
        {id:0, title: 'Fast Food', description: 'Sell groceries and daily needs.' },
        {id:1, title: 'Fine Dinning', description: 'Sell electronics and gadgets.' },
        // {id:2, title: 'Retail Store', description: 'Sell fashion and apparel.' },
        // {id:3, title: 'Online Store', description: 'Sell fashion and apparel.' }
    ];

    const planCards = [
        {id:0, title: 'Basic Plan', description: 'Essential features for small businesses.' },
        {id:1, title: 'Basic Plan + Inventory', description: 'Essential features addtional with inventory handling' },
        {id:2, title: 'Premium Plan', description: 'Advanced features for growing businesses.' },
        // { title: 'Enterprise Plan', description: 'Complete solutions for enterprises.' }
    ];

    const handleNext = () => {
        // Save selectedCard into formData based on step
        if (activeStep === 0 && selectedCard != null) {
            setFormData(prev => ({ ...prev, storeType: storeCards[selectedCard].id }));
        }
        if (activeStep === 1 && selectedCard != null) {
            setFormData(prev => ({ ...prev, planType: planCards[selectedCard].id }));
        }
        setSelectedCard(null); // reset for next step
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => {
        setActiveStep(prev => prev - 1);
        setSelectedCard(null); // optional: reset selected card on back
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Box sx={{ mt: 5 }}>
                {activeStep === 0 && (
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                        {storeCards.map((card, index) => (
                            <Card key={index} sx={{

                                width: '100%',
                                border: selectedCard === index ? 2 : 1, // 2px border when selected, 1px when not
                                borderColor: selectedCard === index ? 'primary.main' : 'grey.300', // primary color if selected
                                boxShadow: selectedCard === index ? 4 : 1, // slightly more shadow for selected
                                transition: 'all 0.3s ease-in-out', // smooth transition
                            }}>

                                <CardActionArea
                                    onClick={() => setSelectedCard(index)}
                                    data-active={selectedCard === index ? '' : undefined}
                                    sx={{
                                        height: '100%',
                                        '&[data-active]': {
                                            backgroundColor: 'action.selected',
                                            '&:hover': {
                                                backgroundColor: 'action.selectedHover',
                                            },
                                        },
                                        padding: 2
                                    }}
                                >
                                    <Grid container>
                                        <Grid item md={3} alignItems={"center"}>
                                            <CardMedia
                                                component="img"
                                                sx={{ width: 100 }}
                                                image="/posimg.png"
                                                alt="Live from space album cover"
                                            />
                                        </Grid>


                                        {/* <IconButton sx={{ p: 0 }}>
                                        <Avatar alt="User Name" src="/logo192.png" />
                                    </IconButton> */}
                                        <Grid item md={8}>
                                            <CardContent sx={{ height: '100%' }}>
                                                <Typography variant="h5" component="div">
                                                    {card.title}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {card.description}
                                                </Typography>
                                            </CardContent>
                                        </Grid>
                                    </Grid>

                                </CardActionArea>
                            </Card>
                        ))}
                    </Box>
                )}

                {activeStep === 1 && (
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                        {planCards.map((card, index) => (
                            <Card key={index} sx={{
                                width: 250, border: selectedCard === index ? 2 : 1, // 2px border when selected, 1px when not
                                borderColor: selectedCard === index ? 'primary.main' : 'grey.300', // primary color if selected
                                boxShadow: selectedCard === index ? 4 : 1, // slightly more shadow for selected
                                transition: 'all 0.3s ease-in-out', // smooth transition 
                            }}>
                                < CardActionArea
                                    onClick={() => setSelectedCard(index)}
                                    data-active={selectedCard === index ? '' : undefined}
                                    sx={{
                                        height: '100%',
                                        '&[data-active]': {
                                            backgroundColor: 'action.selected',
                                            '&:hover': {
                                                backgroundColor: 'action.selectedHover',
                                            },
                                        },
                                    }}
                                >
                                    <CardContent sx={{ height: '100%' }}>
                                        <Typography variant="h5" component="div">
                                            {card.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {card.description}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        ))}
                    </Box>
                )}

                {activeStep === 2 && (
                    <AddCompnayForm setmodel={setshowModaladd} storeType={formData.storeType} planType={formData.planType} />
                )}
            </Box>

            {/* Navigation Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 5 }}>
                <Button disabled={activeStep === 0} onClick={handleBack}>
                    Back
                </Button>

                {activeStep < steps.length - 1 ? (
                    <Button
                        variant="contained"
                        onClick={handleNext}
                        disabled={selectedCard === null} // Disable next until a card is selected
                    >
                        Next
                    </Button>
                ) : null
                }
            </Box>
        </Box >
    );
}
